var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 125 100",
    viewBox: "0 0 125 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#EE7203;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m61.974 30.093c0-0.31174-0.7-0.5542-1.3-0.5542-0.7 0-1.3 0.24246-1.3 0.5542v18.462c0 0.31174 0.7 0.5542 1.3 0.5542 0.7 0 1.3-0.24246 1.3-0.5542z",
    strokeWidth: 0.58854
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.011 18.02s10.012 61.957 20.022 62.069c9.9938 0.11171 54.968-0.01148 65.072 0 9.8502 0.01119 19.911-62.069 19.911-62.069",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m62.644 49.743c-0.26997-0.15587-0.82995 0.32912-1.1299 0.84874-0.35 0.60622-0.44002 1.2471-0.17005 1.4029l15.988 9.2308c0.26997 0.15587 0.82995-0.32912 1.1299-0.84873 0.35-0.60622 0.44002-1.2471 0.17005-1.4029z",
    fill: "#ffcc00",
    strokeWidth: 0.58854
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m60.03 51.988c0.26997-0.15587 0.12995-0.88332-0.17005-1.4029-0.35-0.60622-0.85998-1.0046-1.1299-0.84874l-15.988 9.2308c-0.26997 0.15587-0.12995 0.88332 0.17005 1.4029 0.35 0.60622 0.85998 1.0046 1.1299 0.84874z",
    fill: "#ffcc00",
    strokeWidth: 0.58854
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixe);
export default __webpack_public_path__ + "static/media/mixe.c8b448d545cda52553e5d7a2507071e6.svg";
export { ForwardRef as ReactComponent };